// extracted by mini-css-extract-plugin
module.exports = {"startInput":"rate_startInput__edsGd","startInputWrapper":"rate_startInputWrapper__gwkx-","cancelIcon":"rate_cancelIcon__1cHNP"};